import {LOCALIZATION_SUCCESS} from 'new-constants/api.constants';
import {LocalizationState} from './localization.reducer.types';

const initialState: LocalizationState = {
	translations: {},
	version: 0,
	locale: null,
};

export const localizationReducer = (previousState = initialState, action): LocalizationState => {
	switch (action && action.type) {
		case LOCALIZATION_SUCCESS:
			return {
				...previousState,
				translations: action.payload.data,
				version: action.payload.translationVersion,
				locale: action.payload.locale,
			};
			break;
		default:
			return previousState;
	}
};
